import React from 'react';
import { TablePagination, Paper, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ColumnType } from 'Components/Common/Tables/TableHeaders';
import { pagination } from 'Components/Common/Tables/Tables';
import CustomTable from 'Components/Common/Tables/CustomTable/CustomTable';
import { sortTable } from 'Components/Common/Tables/sortTable';
import OrderTypeArrow from 'Components/Common/Tables/OrderTypeArrow';
import { convertDate } from 'helpers/dayAndTime';
import TableFiltering from 'Components/Reusable/TableFiltering/TableFiltering';

interface P {
	trimList: ColumnType[];
	setTrimList: React.Dispatch<React.SetStateAction<ColumnType[]>>;
}

const SchoolTable = ({
	trimList,
	setTrimList,
	pageSize,
	setPageSize,
	page,
	setPage,
	label,
	orderType,
	setLabel,
	setOrderType,
	setOderBy,
	schools,
	hcaOrgList,
	open,
	setOpen,
	setFilterPayload,
	filterPayload,
	reload,
	setReload,
	handleOpenEdit,
}: any) => {
	const navigate = useNavigate();

	const handleChangePage = (event: unknown, value: number) => {
		setPage(value);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPageSize(+event.target.value);
		setPage(0);
	};

	const handleEdit = (row: any) => {
		console.log('row', row);

		if (hcaOrgList && row?.name && row?.id) {
			setOpen({
				...open,
				state: false,
				data: {
					...open.data,
					organizationId: row?.id,
					organizationName: row?.name,
					address: `${row?.streetline1 && row?.streetline1 !== 'N/A' ? row?.streetline1 + ', ' : ''}${
						row?.streetline2 && row?.streetline2 !== 'N/A' ? row?.streetline2 + ' ' : ''
					}${row?.city && row?.city !== 'N/A' ? row?.city + ' ' : ''}${
						row?.province && row?.province !== 'N/A' ? row?.province + ' ' : ''
					}${row?.postalCode && row?.postalCode !== 'N/A' ? row?.postalCode + ' ' : ''}${
						row?.country && row?.country !== 'N/A' ? row?.country + '' : ''
					}`,
					type: open.type,
				},
				type: '',
			});
			return;
		}
		navigate(`/hca/create-edit-schools/${row.id}`);
	};

	const getTableData = () => {
		return schools?.data?.body?.length
			? schools?.data?.body.map((row: any, index: number) => {
					return {
						id: row.id,
						's/n': page * pageSize + index + 1,
						name: row?.name || 'Anonymous',
						code: row?.code || 'N/A',
						archived: row?.archived ? 'Archived' : 'Active',
						principal: row?.principal || 'N/A',
						phone: row?.phone || 'N/A',
						fax: row?.fax || 'N/A',
						email: row?.email || 'N/A',
						streetline1: row?.streetline1 || 'N/A',
						streetline2: row?.streetline2 || 'N/A',
						city: row?.city || 'N/A',
						postalCode: row?.postalCode || 'N/A',
						province: row?.province?.provinceName || 'N/A',
						country: row?.country || 'N/A',
						diocese: row?.diocese?.dioceseName || 'N/A',
						districtCode: row?.districtCode || 'N/A',
						schoolStatus: row?.schoolStatus.status || 'N/A',
						createdBy: row?.createdBy?.name || 'N/A',
						updatedBy: row?.updatedBy?.name || 'N/A',
						created: row?.created ? `${convertDate(row?.created)}` : 'N/A',
						updated: row?.updated ? `${convertDate(row?.updated)}` : 'N/A',
					};
			  })
			: [];
	};

	const getColumnData = () => {
		return trimList.map((column: ColumnType) => {
			return {
				...column,
				data: (
					<>
						<Tooltip title={column.id == 'actions' ? '' : `Sort by ${column.label}`}>
							<span
								style={{
									cursor: 'pointer',
									margin: '10px',
								}}
								onClick={() => {
									sortTable({
										column: column.id,
										setLabel,
										setOderBy,
										setOrderType,
										orderType,
										label,
									});
								}}
							>
								{column.label}
								{column.id == label && <OrderTypeArrow orderType={orderType} />}
							</span>
						</Tooltip>
						<TableFiltering
							field={column.id}
							filterType={column.filterType}
							list={column.list}
							reload={reload}
							setIsReload={setReload}
							setFilterPayload={setFilterPayload}
							filterPayload={filterPayload}
							page={page}
							setPage={setPage}
						/>
					</>
				),
			};
		});
	};

	const handleDrag = (reOrderedData: ColumnType[]) => {
		reOrderedData && setTrimList?.(reOrderedData);
	};

	const handleResize = (resizedData: ColumnType[]) => {
		resizedData && setTrimList?.(resizedData);
	};

	return (
		<Paper sx={{ width: '100%', overflow: 'hidden' }}>
			<CustomTable
				loading={schools?.loading}
				columnData={getColumnData()}
				tableData={getTableData()}
				handleDrag={handleDrag}
				handleResize={handleResize}
				emptyMessage={'No Schools available'}
				handleRowClick={(row) => {
					handleOpenEdit?.(row as any);
					handleEdit(row as any);
				}}
			/>
			{(schools?.data?.body?.length as number) > 0 && (
				<TablePagination
					rowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
					component="div"
					count={schools?.data?.totalRecords as number}
					rowsPerPage={pageSize}
					page={page}
					sx={pagination}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			)}
		</Paper>
	);
};

export default SchoolTable;
